import {Form, Formik} from "formik";
import React, {Fragment} from "react";
import * as Yup from "yup";
import Card from "../../../components/card/Card";
import ModalMsg from "../../../components/ModalMsg";
import NsButtonNavigazione from "../../../components/buttons/NsButtonNavigazione";
import LabelTradotta from "../../../components/LabelTradotta";
import LabelErroreCampo from "../../../components/fields/LabelErroreCampo";
import NsFormikScrollToError from "../../../components/NsFormikScrollToError";
import NsFilePond from "../../../components/fields/NsFilePond";
import NsDataTable from "../../../components/tabelle/NsDataTable";
import NsButtonActionsGroup from "../../../components/buttons/NsButtonActionsGroup";
import NsButtonAction from "../../../components/buttons/NsButtonAction";
import ModalConfirm from "../../../components/ModalConfirm";
import {Tag} from "primereact/tag";
import {NsCard} from "../../../components/card/NsCard";
import NsField from "../../../components/fields/NsField";
import TabellaKpiConfController from "./components/TabellaKpiConfController";
import {getStrRgba} from "../../../utility/common";

export default function ModificaKpiView({
                                            idKpi,
                                            formikRef,
                                            show,
                                            setShow,
                                            modalMsg,
                                            showConfirmKpiCheckDel,
                                            setShowConfirmKpiCheckDel,
                                            translate,
                                            kpiCheckSel,
                                            SignupSchema,
                                            statiKpi,
                                            macrocategorie,
                                            tipi,
                                            tipiKpi,
                                            loadingTabelle,
                                            configurato,
                                            isRuoloSuperAdmin,
                                            rimuoviStrutturaKpi,
                                            strutturaKpi,
                                            formikRefTabella,
                                            formikRefTemplate,
                                            tabella,
                                            SignupSchemaTemplate,
                                            aggiungiStrutturaKpi,
                                            setTemplate,
                                            formikRefChecks,
                                            aggiungiKpiControllo,
                                            optionsKpiChecks,
                                            relkpiChecks,
                                            setKpiCheckSel,
                                            handleConfirmEliminaRelazioneKpi,
                                            bottoniSx,
                                            bottoniDx,
                                            initialValuesKpi,
                                            initialValuesTemplate,
                                            onSubmitFormKpi,
                                            onSubmitFormTemplate,
                                            handlerChangeTabella,
                                        }) {

    return (
        <div>
            <ModalMsg
                show={show}
                handleClose={() => setShow(false)}
                testo={modalMsg}/>
            <ModalConfirm
                show={showConfirmKpiCheckDel}
                handleClose={() => setShowConfirmKpiCheckDel(false)}
                handleOk={handleConfirmEliminaRelazioneKpi}
                testo={translate("Sicuro di voler eliminare la relazione con il KPI di controllo: ") + (kpiCheckSel && kpiCheckSel.descrizione) + "?"}/>
            <Card
                icon={'fas fa-table'}
                title={idKpi ? 'Modifica KPI' : 'Inserisci KPI'}
                bottoniSx={bottoniSx}
                bottoniDx={bottoniDx}
            >
                <Formik
                    initialValues={initialValuesKpi}
                    innerRef={formikRef}
                    validationSchema={SignupSchema}
                    onSubmit={onSubmitFormKpi}
                >
                    {({errors, touched, values, submitCount}) => (
                        <Form className="row g-3" enctype='multipart/form-data'>
                            <div className="col-md-3">
                                <NsField
                                    name={"codice"}
                                    label={"Codice*:"}
                                    isDisabled={idKpi}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                            <div className="col-md-6">
                                <NsField
                                    name={"descrizione"}
                                    label={"Descrizione*:"}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                            <div className="col-md-3">
                                <NsField
                                    name={"stato"}
                                    label={"Stato*:"}
                                    as={"select"}
                                    options={(statiKpi ? statiKpi.map(o => {
                                        return {
                                            label: o.descrizione,
                                            value: o.id,
                                        };
                                    }) : [])}
                                    valueTemplate={(option, props) => {
                                        if (option) {
                                            if (option.code == 1) {
                                                return <Tag className="mr-2" icon="fas fa-check"
                                                            severity="success" value={translate("Attivo")}/>
                                            } else {
                                                return <Tag className="mr-2" icon="fas fa-times"
                                                            severity="danger" value={translate("Non attivo")}/>
                                            }
                                        }

                                        return <span>{props.placeholder}</span>;
                                    }}
                                    itemTemplate={(option) => {
                                        if (option.code == 1) {
                                            return <Tag className="mr-2" icon="fas fa-check" severity="success"
                                                        value={translate("Attivo")}/>
                                        } else {
                                            return <Tag className="mr-2" icon="fas fa-times" severity="danger"
                                                        value={translate("Non attivo")}/>
                                        }
                                    }}
                                    placeholder={translate("Selezionare uno stato")}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                            <div className="col-md-4">
                                <NsField
                                    name={"id_kpi_macrocategoria"}
                                    label={"Struttura KPI:"}
                                    as={"select"}
                                    options={(macrocategorie ? macrocategorie.map(o => {
                                        return {
                                            label: o.codice + ' - ' + o.descrizione,
                                            value: o.id_kpi_macrocategoria,
                                        };
                                    }) : [])}
                                    placeholder={translate("Selezionare una struttura KPI")}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                            <div className="col-md-4">
                                <NsField
                                    name={"id_classe_tipo_imp_dati"}
                                    label={"Tipo import dati:"}
                                    as={"select"}
                                    options={(tipi ? tipi.map(o => {
                                        return {
                                            label: o.descrizione,
                                            value: o.id_classe_tipo_imp_exp,
                                        };
                                    }) : [])}
                                    placeholder={translate("Selezionare una classe")}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                            <div className="col-md-4">
                                <NsField
                                    name={"id_classe_tipo_exp_dati"}
                                    label={"Tipo export dati:"}
                                    as={"select"}
                                    options={(tipi ? tipi.map(o => {
                                        return {
                                            label: o.descrizione,
                                            value: o.id_classe_tipo_imp_exp,
                                        };
                                    }) : [])}
                                    placeholder={translate("Selezionare una classe")}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                            <div className="col-md-2">
                                <NsField
                                    name={"ordine"}
                                    label={"Ordine:"}
                                    as={"number"}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                            <div className="col-md-2">
                                <NsField
                                    name={"ordine_exp_dati"}
                                    label={"Ordine export dati:"}
                                    as={"number"}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                            <div className="col-md-2">
                                <NsField
                                    name={"tipo_kpi"}
                                    label={"Tipo*:"}
                                    as={"select"}
                                    options={(tipiKpi ? tipiKpi.map(o => {
                                        return {
                                            label: o.descrizione,
                                            value: o.id_tipo_kpi,
                                        };
                                    }) : [])}
                                    valueTemplate={(option, props) => {
                                        if (option) {
                                            let optFiltrata = tipiKpi.filter((opt) => opt.id_tipo_kpi == option.code);
                                            if (optFiltrata && optFiltrata.length > 0) {
                                                return (
                                                    <Tag value={optFiltrata[0].descrizione}
                                                         className="mr-2"
                                                         style={{
                                                             backgroundColor: getStrRgba(optFiltrata[0].colore),
                                                         }}
                                                    />
                                                );
                                            }
                                        }

                                        return <span>{props.placeholder}</span>;
                                    }}
                                    itemTemplate={(option) => {
                                        let optFiltrata = tipiKpi.filter((opt) => opt.id_tipo_kpi == option.code);
                                        if (optFiltrata && optFiltrata.length > 0) {
                                            return (
                                                <Tag value={optFiltrata[0].descrizione}
                                                     className="mr-2"
                                                     style={{
                                                         backgroundColor: getStrRgba(optFiltrata[0].colore),
                                                     }}
                                                />
                                            );
                                        }
                                    }}
                                    placeholder={translate("Selezionare un tipo")}
                                    isDisabled={idKpi}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                            <div className="col-md-2">
                                <NsField
                                    name={"gg_scadenza"}
                                    label={"Giorno Scadenza*:"}
                                    as={"number"}
                                    valMaxNumeric={31}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                            <div className="col-md-2">
                                <NsField
                                    name={"mm_scadenza"}
                                    label={"Mese Scadenza*:"}
                                    as={"number"}
                                    valMaxNumeric={12}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                            <NsFormikScrollToError submitCount={submitCount} errors={errors}/>
                        </Form>
                    )}
                </Formik>
            </Card>
            {
                idKpi && idKpi !== '' && !loadingTabelle &&
                <Fragment>
                    {
                        configurato ?
                            <NsCard
                                icon={'fas fa-table'}
                                title={'Tabelle KPI'}
                                getBottoniDx={() =>
                                    <Fragment>
                                        {
                                            isRuoloSuperAdmin() &&
                                            <NsButtonNavigazione
                                                name={"elimina"}
                                                label={"Elimina"}
                                                icona={"fas fa-trash"}
                                                onClick={rimuoviStrutturaKpi}
                                            />
                                        }
                                    </Fragment>
                                }>
                                <TabellaKpiConfController
                                    tabella={strutturaKpi}
                                    formikRef={formikRefTabella}
                                    idKpi={idKpi}
                                    handlerChange={handlerChangeTabella}
                                />
                            </NsCard>
                            :
                            isRuoloSuperAdmin() &&
                            <NsCard
                                icon={'fas fa-upload'}
                                title={'Carica template'}
                                getBottoniDx={() =>
                                    <Fragment>
                                        <NsButtonNavigazione
                                            name={"carica"}
                                            label={"Carica"}
                                            icona={"fas fa-upload"}
                                            onClick={() => {
                                                formikRefTemplate.current?.handleSubmit();
                                            }}
                                        />
                                        <NsButtonNavigazione
                                            name={"salva"}
                                            label={"Salva"}
                                            icona={"fas fa-save"}
                                            disabled={!tabella}
                                            onClick={aggiungiStrutturaKpi}
                                        />
                                    </Fragment>
                                }>
                                <Formik
                                    initialValues={initialValuesTemplate}
                                    innerRef={formikRefTemplate}
                                    validationSchema={SignupSchemaTemplate}
                                    onSubmit={onSubmitFormTemplate}
                                >
                                    {({errors, touched, values, submitCount}) => (
                                        <Form className="row g-3">
                                            <div className="col-md-4">
                                                <LabelTradotta htmlFor={"file"}>File template:</LabelTradotta>
                                                <NsFilePond
                                                    id={"file"}
                                                    acceptedFileTypes={[
                                                        'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                                                    ]}
                                                    handleFiles={(file) => {
                                                        setTemplate(file);
                                                        formikRefTemplate.current.setFieldValue("file", file ? '1' : '');
                                                    }}
                                                />
                                                <LabelErroreCampo errors={errors} touched={touched}
                                                                  name={"file"}
                                                                  submitCount={submitCount}/>
                                            </div>
                                            {
                                                tabella &&
                                                <div className={"row mt-4"}>
                                                    <div className={"col-md-12"}>
                                                        <h3>Anteprima:</h3>
                                                    </div>
                                                    <div className={"col-md-12"}>
                                                        <TabellaKpiConfController
                                                            tabella={tabella.tabella}
                                                            formikRef={formikRefTabella}
                                                            idKpi={idKpi}
                                                            handlerChange={handlerChangeTabella}
                                                        />
                                                    </div>
                                                </div>
                                            }

                                            <NsFormikScrollToError submitCount={submitCount} errors={errors}/>
                                        </Form>
                                    )}
                                </Formik>
                            </NsCard>
                    }
                    {
                        /*
                         * Associazione KPI - Checks
                         */
                        idKpi &&
                        <NsCard
                            title={'Controlli completamento'}
                            icon={'fas fa-tasks'}
                            getBottoniDx={() =>
                                <NsButtonNavigazione
                                    nome={"aggiungiCks"}
                                    label={"Aggiungi"}
                                    icona={"fas fa-plus-circle"}
                                    onClick={() => {
                                        if (formikRefChecks.current) {
                                            formikRefChecks.current.handleSubmit()
                                        }
                                    }}
                                />
                            }>
                            <Formik
                                initialValues={{
                                    id_kpi_check: ''
                                }}
                                innerRef={formikRefChecks}
                                validationSchema={Yup.object().shape({
                                    id_kpi_check: Yup.string()
                                        .required(translate('Questo campo è obbligatorio'))
                                })}
                                onSubmit={aggiungiKpiControllo}
                            >
                                {({errors, touched, values, submitCount}) => (
                                    <Form className="row g-3">
                                        <div className="col-md-6">
                                            <NsField
                                                name={"id_kpi_check"}
                                                label={"KPI controlli*:"}
                                                as={"select"}
                                                options={(optionsKpiChecks ? optionsKpiChecks.map(o => {
                                                    return {
                                                        label: o.descrizione,
                                                        value: o.id_kpi,
                                                    };
                                                }) : [])}
                                                placeholder={translate("Selezionare un KPI controllo")}
                                                formikRef={formikRefChecks}
                                                values={values}
                                                errors={errors}
                                                touched={touched}
                                                submitCount={submitCount}
                                            />
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                            <div className={"pt-3"}>
                                <NsDataTable
                                    data={relkpiChecks}
                                    columns={[
                                        {
                                            name: translate('Codice'),
                                            selector: row => row.codice,
                                            sortable: true,
                                        },
                                        {
                                            name: translate('Descrizione'),
                                            selector: row => row.descrizione,
                                            sortable: true,
                                        },
                                        {
                                            name: '',
                                            selector: row => <NsButtonActionsGroup>
                                                <li>
                                                    <NsButtonAction
                                                        label={"Elimina"}
                                                        icona={"fas fa-trash"}
                                                        onClick={() => {
                                                            setKpiCheckSel(row);
                                                            setShowConfirmKpiCheckDel(true);
                                                        }}
                                                    />
                                                </li>
                                            </NsButtonActionsGroup>,
                                            sortable: false,
                                            right: true,
                                        }
                                    ]}
                                />
                            </div>
                        </NsCard>
                    }
                </Fragment>
            }
        </div>
    );
}